import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CatalogStatus } from '@/modules/service-purchase/types';
import { GenericChip } from '@/modules/shared/components/chips/generic-chip/generic-chip';
interface CatalogStatusProps {
  catalogStatus: CatalogStatus;
  className?: string;
}
function ServiceCatalogStatus(t0) {
  const $ = _c(7);
  const {
    catalogStatus,
    className
  } = t0;
  let t1;
  bb0: {
    switch (catalogStatus) {
      case CatalogStatus.Optional:
        {
          let t2;
          if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Optional",
              color: "blue"
            };
            $[0] = t2;
          } else {
            t2 = $[0];
          }
          t1 = t2;
          break bb0;
        }
      case CatalogStatus.Included:
        {
          let t2;
          if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Included",
              color: "green"
            };
            $[1] = t2;
          } else {
            t2 = $[1];
          }
          t1 = t2;
          break bb0;
        }
      case CatalogStatus.Excluded:
        {
          let t2;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Excluded",
              color: "red"
            };
            $[2] = t2;
          } else {
            t2 = $[2];
          }
          t1 = t2;
          break bb0;
        }
    }
    t1 = undefined;
  }
  const {
    label,
    color
  } = t1;
  let t2;
  if ($[3] !== className || $[4] !== color || $[5] !== label) {
    t2 = <GenericChip variant="filled" color={color} className={className}>{label}</GenericChip>;
    $[3] = className;
    $[4] = color;
    $[5] = label;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export { ServiceCatalogStatus };